import React, { useCallback, useEffect, useState } from "react";
import { CalendarClock, Send } from "lucide-react";
import { practiceApi } from "../lib/practiceApi";

const formatMoment = (value) => {
  if (!value) return "—";
  const moment = new Date(value);
  return Number.isNaN(moment.getTime()) ? value : moment.toLocaleString("it-IT", { dateStyle: "medium", timeStyle: "short", timeZone: "Europe/Rome" });
};

export function DigestSchedule({ onError, onDone }) {
  const [schedule, setSchedule] = useState(null);
  const [busy, setBusy] = useState("");

  const load = useCallback(async () => {
    try { setSchedule(await practiceApi("/notifications/schedule")); }
    catch (err) { onError(err.message); }
  }, [onError]);

  useEffect(() => { load(); }, [load]);

  async function refresh() {
    setBusy("refresh");
    try { setSchedule(await practiceApi("/notifications/schedule/refresh", { method: "POST" })); onDone("Programmazione aggiornata"); }
    catch (err) { onError(err.message); } finally { setBusy(""); }
  }

  async function sendNow() {
    setBusy("send"); onError("");
    try {
      const result = await practiceApi("/notifications/digest/send", { method: "POST" });
      onDone(`Riepilogo inviato a ${result.sent} destinatari (scadenze entro ${result.horizon_days} giorni)`);
      await load();
    } catch (err) { onError(err.message); } finally { setBusy(""); }
  }

  const next = schedule?.jobs?.find(job => job.id === "weekly_digest")?.next_run;

  return <div className="digest-box" data-testid="digest-schedule">
    <div>
      <strong><CalendarClock size={15} /> Prossimo invio automatico</strong>
      <small data-testid="digest-next-run">{formatMoment(next)} · fuso orario Europe/Rome</small>
      <small>Ultimo invio: {formatMoment(schedule?.last_digest_at)}</small>
    </div>
    <div className="digest-actions">
      <button type="button" className="ghost" disabled={!!busy} data-testid="digest-send-now" onClick={sendNow}>
        <Send size={15} />{busy === "send" ? "Invio…" : "Invia il riepilogo ora"}
      </button>
      <button type="button" className="ghost" disabled={!!busy} data-testid="digest-refresh" onClick={refresh}>
        {busy === "refresh" ? "Aggiornamento…" : "Applica giorno e ora"}
      </button>
    </div>
    <small className="settings-asset-hint">Salva le impostazioni e premi "Applica giorno e ora" per riprogrammare l'invio automatico.</small>
  </div>;
}
